import React from 'react';
import Icon from './Icon';

const oldItems = [
  'Replies to messages',
  'Asks qualification questions',
  'Drops a meeting on the calendar',
  'Stops there. The rest is on you.'
];

const newItems = [
  'Welcomes, qualifies and handles objections',
  'Follows up with silent prospects, at the right time',
  'Closes: meeting, direct sale, or sign-up',
  'Centralizes all 10 channels into one conversation',
  'Hands over to you exactly when it matters'
];

function Repositioning() {
  return (
    <section id="difference" className="reposition">
      <div className="wrap">
        <div className="sec-head">
          <div className="eyebrow" style={{ color: 'var(--wa)' }}>The difference</div>
          <h2>An "AI setter" books meetings.<br />A sales operator drives revenue.</h2>
          <p style={{ color: '#aeb6c2' }}>The nuance isn't marketing. It changes what lands in your bank account at the end of the month.</p>
        </div>
        <div className="repo-grid">
          <div className="repo-col old">
            <div className="tag">A typical AI setter</div>
            <ul>
              {oldItems.map((item, i) => (
                <li key={i}><span className="mk">—</span>{item}</li>
              ))}
            </ul>
          </div>
          <div className="repo-col new">
            <div className="tag">Salesyo, sales operator</div>
            <ul>
              {newItems.map((item, i) => (
                <li key={i}><span className="mk"><Icon name="check" /></span>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Repositioning;
